<div class="modal-overlay" *ngIf="modalAberto" (click)="fecharModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="fecharModal()">✕</button>
    <iframe
      width="100%"
      height="100%"
      src="https://www.youtube.com/embed/OvCD0HKlJ-4"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen>
    </iframe>
  </div>
</div>

<div class="main-bg">

  <section class="hero">
    <div class="hero-content">
      <h1 class="hero-title">
        De extratos e notas fiscais
        <span>à lançamentos contábeis estruturados!</span>
      </h1>
      <p class="hero-subtitle">
        Mister Contador. Automação contábil que transforma insumos em contabilidade organizada e pronta para o fechamento. 
      </p>
      <div class="hero-actions">
        <a href="#" class="btn-assistir" (click)="abrirModal(); $event.preventDefault()">▶ Assista a apresentação</a>
        <a href="#" class="btn-conheca">Ver como funciona</a>
      </div>

    </div>

    <div class="hero-glass-cube">
      <app-glass-cube></app-glass-cube>
    </div>

  </section>

  <section class="preview-cta">
    <span class="preview-cta-badge">Simples assim</span>
    <h2 class="preview-cta-title">
      Capture <span>extratos e comprovantes</span><br> de forma rápida e simples, direto na origem.
    </h2>
    <p class="preview-cta-sub">Veja abaixo como funciona na prática — experimente agora.</p>
  </section>

  <div class="mockup-wrapper" [class.obscurecido]="!guiaMockup">
    <app-sistema-mockup [guiaAtivo]="guiaMockup"></app-sistema-mockup>
    <div class="mockup-overlay" *ngIf="!guiaMockup" (click)="iniciarGuia()">
      <button class="btn-overlay-comecar">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        Começar demonstração
      </button>
    </div>
  </div>


</div>

<div class="divider"></div>

<section class="hero-2">
  <div class="hero-content">

    <h2 class="hero-title-2">
      Conheça a <span>Precisão!</span>
    </h2>

    <p class="hero-subtitle-2">
      O Mister Contador concilia extratos, notas fiscais e comprovantes para estruturar um lançamento contábil impecável.
    </p>

    <img class="hero-2-notebook" src="assets/img/notebook.png" alt="Notebook" />



  </div>
  
      <div class="cards">

      <div class="card">
        <div class="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </div>
        <h3>Captura de insumos</h3>
        <p>Extratos bancários, notas fiscais e comprovantes capturados de forma integrada, reduzindo a dependência de envio manual pelo cliente.</p>
      </div>

      <div class="card">
        <div class="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
          </svg>
        </div>
        <h3>Conciliação automática</h3>
        <p>Os insumos são cruzados automaticamente, garantindo consistência entre movimentações financeiras e documentos fiscais.</p>
      </div>

      <div class="card">
        <div class="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
          </svg>
        </div>
        <h3>Escrituração contábil</h3>
        <p>Os lançamentos são organizados conforme o plano de contas, prontos para revisão e exportação para o ERP.</p>
      </div>

    </div>

  <div class="hero-2-faixa">
    <div class="marquee">
      <div class="marquee-track">
        <span>Identificação e contabilização da Tarifa de Boleto <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Criação de regras de associação personalizada por cliente (futuro) <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Importação do plano de contas de cada cliente <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Quantifica o volume de lançamentos feitos <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Filtro de lançamentos conciliados ou não <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Apresentação dos comprovantes de pagamento e respectivas notas fiscais <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Identificação e contabilização da Tarifa de Boleto <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Criação de regras de associação personalizada por cliente (futuro) <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Importação do plano de contas de cada cliente <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Quantifica o volume de lançamentos feitos <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Filtro de lançamentos conciliados ou não <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Apresentação dos comprovantes de pagamento e respectivas notas fiscais <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
      </div>
    </div>
  </div>

</section>

<app-neural-bank></app-neural-bank>
<div class="divider"></div>

<section class="cta-white">
  <div class="cta-white-inner">
    <h2 class="cta-white-title">Estruture o seu departamento contábil com mais eficiência e controle!</h2>
    <p class="cta-white-subtitle">Veja na prática como reduzir a dependência de processos manuais e ganhar mais previsibilidade na sua rotina contábil.</p>
    <a href="https://api.whatsapp.com/send/?phone=5548991707731" target="_blank" rel="noopener noreferrer" class="cta-white-btn">Agende sua demonstração</a>
  </div>
</section>

<div class="divider"></div>

<section class="hero-3">
  <div class="hero-content">

    <h2 class="hero-title-3">
      O Mister Contador já faz parte da rotina de escritórios contábeis em <span>Todo Brasil!</span>
    </h2>

    <p class="hero-subtitle-3">
      Veja como a tecnologia contribui para a rotina de mais de 2500 equipes contábeis por todo o país.
    </p>

  </div>

  <div class="hero-3-image">

    <div class="comment comment-tl">
      <div class="comment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>"O Mister trouxe mais segurança na entrega dos balancetes."</p>
    </div>

    <div class="comment comment-tr">
      <div class="comment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>"Finalmente encontrei uma ferramenta que entrega a precisão que meus clientes exigem."</p>
    </div>

    <div class="comment comment-ml">
      <div class="comment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>"O Mister realmente entrega uma abordagem diferente do que já existe no mercado."</p>
    </div>

    <div class="comment comment-mr">
      <div class="comment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>"Com o Mister Contador, consegui aumentar a precisão e a velocidade da minha contabilidade."</p>
    </div>

    <div class="comment comment-cl">
      <div class="comment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>"Sem o Mister Contador, a rotina contábil fica muito mais limitada."</p>
    </div>

    <div class="comment comment-bl">
      <div class="comment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>"As integrações trouxeram um ganho de tempo significativo na operação."</p>
    </div>

    <div class="comment comment-br">
      <div class="comment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>"Foi a primeira plataforma que a equipe adotou com facilidade e resultado desde o início."</p>
    </div>

    <img loading="lazy" src="assets/img/astronauta3.png" alt="Astronauta" />

  </div>

  

</section>

<div class="hero-2-faixa">
    <div class="marquee">
      <div class="marquee-track">
        <span>Identificação e contabilização da Tarifa de Boleto <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Criação de regras de associação personalizada por cliente (futuro) <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Importação do plano de contas de cada cliente <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Quantifica o volume de lançamentos feitos <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Filtro de lançamentos conciliados ou não <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Apresentação dos comprovantes de pagamento e respectivas notas fiscais <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Identificação e contabilização da Tarifa de Boleto <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Criação de regras de associação personalizada por cliente (futuro) <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Importação do plano de contas de cada cliente <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Quantifica o volume de lançamentos feitos <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Filtro de lançamentos conciliados ou não <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Apresentação dos comprovantes de pagamento e respectivas notas fiscais <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
      </div>
    </div>
  </div>

<section class="hero-4">
  <div class="hero-4-text">
    <h2 class="hero-title-4">Como aplicar o Mister Contador na rotina do seu escritório!</h2>
    <p class="hero-subtitle-4">Em poucos passos, você integra seus insumos, acompanha a conciliação e validar os lançamentos antes da exportação.</p>
  </div>

  <div class="hero-4-steps">

    <div class="step-card">
      <div class="step-badge">
        <span>1</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
      </div>
      <h3>Integre os insumos</h3>
      <p>Conecte extratos bancários, notas fiscais e comprovantes diretamente ao Mister ou faça upload manual do arquivos.</p>
    </div>

    <div class="step-card">
      <div class="step-badge">
        <span>2</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path></svg>
      </div>
      <h3>Acompanhe a conciliação</h3>
      <p>Visualize como os dados são cruzados automaticamente em poucos segundos e identifique possíveis ajustes.</p>
    </div>

    <div class="step-card">
      <div class="step-badge">
        <span>3</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
      </div>
      <h3>Revise e exporte</h3>
      <p>Valide os lançamentos estruturados e envie para o seu ERP.</p>
    </div>

  </div>
</section>

<section class="performance">
  <div class="performance-header">
    <h2 class="performance-title">Sua contabilidade pode operar em outro nível</h2>
    <p class="performance-subtitle">Impactos reais na performance do seu escritório contábil.</p>
  </div>

  <div class="performance-grid">

    <div class="perf-card perf-dark">
      <div class="perf-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </div>
      <p>Menos digitação, mais controle nos lançamentos</p>
    </div>

    <div class="perf-card perf-blue perf-center">
      <div class="perf-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
      </div>
      <p>Fechamentos mais rápidos e previsíveis</p>
      <div class="perf-clock">
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="12" x2="16" y2="14"></line><line x1="12" y1="2" x2="12" y2="1"></line><line x1="12" y1="23" x2="12" y2="22"></line></svg>
      </div>
    </div>

    <div class="perf-card perf-dark">
      <div class="perf-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
      </div>
      <p>Mais produtividade para o time</p>
    </div>

    <div class="perf-card perf-dark">
      <div class="perf-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
      </div>
      <p>Menos dependência do cliente no dia a dia</p>
    </div>

    <div class="perf-card perf-dark">
      <div class="perf-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 17 13.5 8.5 8.5 13.5 2 7"></polyline><polyline points="16 17 22 17 22 11"></polyline></svg>
      </div>
      <p>Operação mais organizada e centralizada</p>
    </div>

    <div class="perf-card perf-dark perf-bottom-center">
      <div class="perf-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
      </div>
      <p>Crescimento com consistência operacional</p>
    </div>

  </div>
</section>

  <div class="hero-2-faixa">
    <div class="marquee">
      <div class="marquee-track">
        <span>Identificação e contabilização da Tarifa de Boleto <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Criação de regras de associação personalizada por cliente (futuro) <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Importação do plano de contas de cada cliente <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Quantifica o volume de lançamentos feitos <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Filtro de lançamentos conciliados ou não <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Apresentação dos comprovantes de pagamento e respectivas notas fiscais <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Identificação e contabilização da Tarifa de Boleto <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Criação de regras de associação personalizada por cliente (futuro) <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Importação do plano de contas de cada cliente <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Quantifica o volume de lançamentos feitos <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Filtro de lançamentos conciliados ou não <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
        <span>Apresentação dos comprovantes de pagamento e respectivas notas fiscais <img src="assets/img/icons8-verified-badge-48.png" class="marquee-icon" alt="verificado" /></span>
      </div>
    </div>
  </div>

<section class="integracoes" id="integracoes">
  <div class="integracoes-inner">

    <div class="integracoes-tag">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
      Integrações Únicas
    </div>

    <h2 class="integracoes-title">Integrações com as principais fontes da sua contabilidade.</h2>

    <p class="integracoes-subtitle">
      O Mister Contador integra extratos bancários e comprovantes de diversos bancos e é compatível com os principais ERPs contábeis do mercado, te entregando uma performance excepcional.
    </p>

    <div class="integracoes-cards">

      <div class="integ-card">
        <div class="integ-card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
        </div>
        <h3>Integração Nativa<br>Cora &amp; Inter</h3>
        <p>Esse é o ápice da tecnologia revolucionária da contabilidade automática. A integração captura os extratos bancários e comprovantes de pagamento do seu cliente, elaborando a escrituração contábil em segundos.</p>
        <div class="integ-logos-track-wrap">
          <div class="integ-logos-track">
            <img src="assets/img/cora.svg" alt="Cora" />
            <img src="assets/img/inter.svg" alt="Inter" />
            <img src="assets/img/cora.svg" alt="Cora" />
            <img src="assets/img/inter.svg" alt="Inter" />
            <img src="assets/img/cora.svg" alt="Cora" />
            <img src="assets/img/inter.svg" alt="Inter" />
            <img src="assets/img/cora.svg" alt="Cora" />
            <img src="assets/img/inter.svg" alt="Inter" />
          </div>
        </div>
      </div>

      <div class="integ-card">
        <div class="integ-card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
        </div>
        <h3>Integração via OpenFinance</h3>
        <p>Importe automaticamente a movimentação bancária dos 20 maiores bancos do Brasil. A união de uma importação automática de extratos com regras bem definidas, te tornam capaz de exterminar a contabilidade atrasada e a digitação da escrituração futura.</p>
        <div class="integ-logos-track-wrap">
          <div class="integ-logos-track">
            <img src="assets/img/bradesco.svg" alt="Bradesco" />
            <img src="assets/img/caixa.svg" alt="Caixa" />
            <img src="assets/img/itau.svg" alt="Itaú" />
            <img src="assets/img/santander.svg" alt="Santander" />
            <img src="assets/img/sicredi.svg" alt="Sicredi" />
            <img src="assets/img/sicoob.svg" alt="Sicoob" />
            <img src="assets/img/btg.svg" alt="BTG" />
            <img src="assets/img/banrisul.svg" alt="Banrisul" />
            <img src="assets/img/bancodobrasil.svg" alt="Banco do Brasil" />
            <img src="assets/img/nubank.svg" alt="Nubank" />
            <img src="assets/img/bradesco.svg" alt="Bradesco" />
            <img src="assets/img/caixa.svg" alt="Caixa" />
            <img src="assets/img/itau.svg" alt="Itaú" />
            <img src="assets/img/santander.svg" alt="Santander" />
            <img src="assets/img/sicredi.svg" alt="Sicredi" />
            <img src="assets/img/sicoob.svg" alt="Sicoob" />
            <img src="assets/img/btg.svg" alt="BTG" />
            <img src="assets/img/banrisul.svg" alt="Banrisul" />
            <img src="assets/img/bancodobrasil.svg" alt="Banco do Brasil" />
            <img src="assets/img/nubank.svg" alt="Nubank" />
          </div>
        </div>
        <div class="integ-logos-track-wrap">
          <div class="integ-logos-track integ-logos-track--reverse">
            <img src="assets/img/mercadopago.svg" alt="Mercado Pago" />
            <img src="assets/img/bmg.svg" alt="BMG" />
            <img src="assets/img/unicred.svg" alt="Unicred" />
            <img src="assets/img/bnb.svg" alt="BNB" />
            <img src="assets/img/safra.svg" alt="Safra" />
            <img src="assets/img/xp.svg" alt="XP" />
            <img src="assets/img/paulista.svg" alt="Banco Paulista" />
            <img src="assets/img/bv.svg" alt="BV" />
            <img src="assets/img/infinitepay.svg" alt="InfinitePay" />
            <img src="assets/img/mercadopago.svg" alt="Mercado Pago" />
            <img src="assets/img/bmg.svg" alt="BMG" />
            <img src="assets/img/unicred.svg" alt="Unicred" />
            <img src="assets/img/bnb.svg" alt="BNB" />
            <img src="assets/img/safra.svg" alt="Safra" />
            <img src="assets/img/xp.svg" alt="XP" />
            <img src="assets/img/paulista.svg" alt="Banco Paulista" />
            <img src="assets/img/bv.svg" alt="BV" />
            <img src="assets/img/infinitepay.svg" alt="InfinitePay" />
          </div>
        </div>
      </div>

    </div>

    <div class="integ-cards-wide">

      <div class="integ-wide-card">
        <div class="integ-wide-left">
          <div class="integ-card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
          </div>
          <h3>Integração HüB SIEG</h3>
          <p>Importe automaticamente para o Mister, as Notas Fiscais capturadas no SIEG HüB e elabore o histórico contábil mais preciso e detalhado da sua vida.</p>
        </div>
        <div class="integ-wide-right integ-wide-right--sieg">
          <div class="sieg-tablet">
            <span class="sieg-logo-text">
              <img src="assets/img/logo.png" alt="Mister" class="sieg-mister-logo" />
              <span class="sieg-plus">+</span>
              <span class="sieg-sieg">SiEG</span>
            </span>
          </div>
        </div>
      </div>

      <div class="integ-wide-card">
        <div class="integ-wide-left">
          <div class="integ-card-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
          </div>
          <h3>Processamento eletrônico de extratos de mais de 160 Bancos</h3>
          <p>Apresentação em tela dos comprovantes de pagamento e respectivas notas fiscais. O Mister foi projetado para produzir contabilidade automática até para os seus clientes que nem mesmo compartilham os comprovantes dos pagamentos realizados.</p>
        </div>
        <div class="integ-wide-right integ-wide-right--dark">
          <p>Saiba mais sobre todas nossas Integrações</p>
        </div>
      </div>

    </div>

  </div>
</section>

<section class="faq">
  <div class="faq-inner">

    <h2 class="faq-title">Perguntas <span>Frequentes</span></h2>

    <div class="faq-list">
      <div
        class="faq-item"
        *ngFor="let item of faqItems; let i = index"
        [class.faq-item--open]="faqAberto === i"
      >
        <button class="faq-question" (click)="toggleFaq(i)">
          <span>{{ item.pergunta }}</span>
          <div class="faq-btn-icon">
            <svg *ngIf="faqAberto !== i" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            <svg *ngIf="faqAberto === i" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </div>
        </button>
        <div class="faq-answer" *ngIf="faqAberto === i">
          <p>{{ item.resposta }}</p>
        </div>
      </div>
    </div>

  </div>
</section>
